import React from 'react';

import { useParams } from 'react-router-dom';

import TableHeader from '../../../../../components/Table/TableHeader';
import TablePagination from '../../../../../components/Table/TablePagination';
import FormControl from '@material-ui/core/FormControl';
import InputSearch from '../../../../../components/InputSearch';

const tabelaColunas = ['Nome', 'E-mail', 'Status', ]

const ListaUsuarioBuyer = ({ 
    data,
    buscar,
    busca,
    mudarPagina,
    chamarForm,
    gerarExcel
}) => {
    
    const changePage = (page) => {
        mudarPagina(page);
    }

    return (
        <div>
            <div className="row mt20">
                <div className="col-sm-12 col-md-12 col-lg-12 descricao ml-1">
                    <h1 className='label-second'>Usuários Cadastrados</h1>
                </div>
            </div>
            <div className='row mt20'>
                <div className='col-sm-3 col-md-3 col-lg-3'>
                    <button 
                        onClick={() => chamarForm(7)} className="buton-green btn btn-block btn-lg mt20"
                    >
                        NOVO USUÁRIO
                    </button>
                </div>

                <div className='col-sm-3 col-md-3 col-lg-3'>
                    <button 
                        className="buton-white-black-border btn btn-block btn-lg mt20"
                        onClick={() => gerarExcel()}
                    >
                        EXTRAIR BASE
                    </button>
                </div>
            </div>
            <div className="row justify-content-end">
                <div className='col-md-3'>
                    <FormControl>
                        <InputSearch
                            buscar={buscar}
                            buscaPor={busca}
                        />
                    </FormControl>
                </div>
            </div>
            <div className="row">
                <div className='col-12 mt20'>
                    <div className="table-responsive">
                        <table className="table">
                            <TableHeader columns={tabelaColunas} />

                            <tbody>
                                {
                                    data?.lista === 0 &&
                                    <tr><td colSpan="7"> Sem Registros </td></tr>
                                }

                                {
                                       data?.lista && data?.lista?.map((user) => (
                                        <tr key={user.id}>
                                            <td> {user.nome} </td>
                                            <td> {user.email} </td>
                                            <td> {user.ativo ? 'Ativo' : 'Inativo'} </td>
                                            <td className="text-right">
                                                <i className="btn-edit-icon btn btn-icon fa fa-edit" onClick={() => chamarForm(7, user.id)}></i>
                                            </td>
                                        </tr>
                                    ))
                                }
                            </tbody>
                        </table>
                        <TablePagination data={data} changePage={changePage} />
                    </div>
                </div>
            </div>
        </div>
    );
}

export default ListaUsuarioBuyer;